module.exports = __webpack_public_path__ + "img/14_zh.dd04c792.jpg";